export const FPS_144 = 6.944444444444444;
export const FPS_60 = 16.66666666666667;
export const FPS_30 = 33.33333333333333;

export const MathPI2 = Math.PI * 2;

export const DegreeInRad = Math.PI / 180;
